import { buildUmiLocaleMessages } from "./shared";

export default buildUmiLocaleMessages("en");
